<template>
  <div id="appRoot" class="document">
    <Header />
    <router-view />
    <Footer />

    <transition name="toast">
      <div v-if="toast" class="toast">
        <div class="toast-inner">{{ toast }}</div>
      </div>
    </transition>
  </div>
</template>

<script>
import i18n, { checkDefaultLanguage } from '@/i18n'
import { mapActions } from 'vuex'
import { getLang, getLangData, setLanguage } from './util'

export default {
  name: 'App',
  components: {
    Header: () => import('@/components/layout/Header'),
    Footer: () => import('@/components/layout/Footer')
  },
  data () {
    return {
      toast: ''
    }
  },
  watch: {
    '$route.params.locale' (v) {
      const locale = v === undefined || v.length <= 0 ? 'ko' : v

      setLanguage(locale)
      this.$i18n.locale = locale
    }
  },
  created () {
    // 브라우저 혹은 로컬스토리지에 lang 체크
    let locale = checkDefaultLanguage()

    // routes arr 1차원 배열로 바꾸기.
    const newRoutes = this.newRoutes()

    // 처음 접속했을때 브라우저의 lang를 체크해서 url 변경시켜줌
    this.nowLocationName(locale, newRoutes)

    // 로컬스토리지에 보관된 lang data 가져오기
    const localLang = getLangData()

    if (window.location.pathname.includes('/en')) {
      locale = 'en'
    }

    const params = new URLSearchParams(window.location.search)
    const queryLang = params.get('lang')
    if (queryLang) {
      locale = queryLang === 'EN' ? 'en' : 'ko'
    }

    // 처음 접속시 global data가 로컬스토리지에 있는지 확인하고 없으면 가져오기.
    getLang(locale, 'global')

    // 로컬스토리지에서 가져온 lang data i18n에 넣기.
    if (localLang) {
      Object.keys(localLang).map((lang) => {
        Object.keys(localLang[lang]).map(category => {
          i18n.mergeLocaleMessage(lang, localLang[lang][category].data || {})
        })
      })
    } else {
      window.localStorage.setItem('lang', locale)
    }

    // 초기 언어 설정
    setLanguage(locale)

    this.$i18n.locale = locale
    this.localStorageChange(locale)

    this.getConnectionSite()
    this.getWritingCategory()

    this.$root.$on('toast:show', ({ text }) => {
      this.toast = text

      setTimeout(() => {
        this.toast = ''
        this.$root.$emit('toast:hide')
      }, 3000)
    })
  },
  mounted () {
    const appHeight = () => {
      const doc = document.documentElement
      doc.style.setProperty('--app-height', `${window.innerHeight}px`)
    }
    appHeight()
  },
  methods: {
    ...mapActions({
      localStorageChange: 'locale/localStorageChange',
      getConnectionSite: 'site/getConnectionSite',
      getWritingCategory: 'categories/getWritingCategory'
    }),
    newRoutes () {
      const newArr = []
      const routes = (arr, path) => {
        arr.forEach(el => {
          el.path = path ? `${path}/${el.path}` : `${el.path}`
          if (el.children) {
            routes(el.children, el.path)
          }
          newArr.push(el)
        })
      }
      routes(this.$router.options.routes)

      return newArr
    },
    nowLocationName (locale, arr) {
      // routes arr에서 현재 url path값을 비교해서 name가져오기. lang 호출할때 이름으로 사용하기 때문에 필요.
      const nowLocation = arr.filter(v => {
        const routePath = v.path.slice(16)
        let nowPath = window.location.pathname.replace(/^\/en/ig, '')
        if (nowPath === '') {
          nowPath = '/'
        }
        return routePath === nowPath
      })

      if (nowLocation[0]?.name) {
        this.$router.push({
          name: nowLocation[0].name,
          params: {
            locale: locale === 'ko' ? '' : locale
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
@import "~@/static/scss/index";
</style>
